
export const BILAN_LOCALSTORAGE_KEY = "bilan";
export const AUTH_LOCALSTORAGE_KEY = "auth";
export const MESSAGE_LOCALSTORAGE_KEY = "message";
export const SITE_URL = "https://ortho-initiative.fr";
//export const SITE_URL = "http://api.bilan-ortho.test";
export const MATRAM_URL = `${SITE_URL}/matram`;
